import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description InsuranceHouse icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { InsuranceHouse } from '@sravni/design-system-icons'
 *
 * <InsuranceHouse />
 * ```
 */
var InsuranceHouse = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "InsuranceHouse", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.833 13.333h8.334M5.833 15.833h8.334M5.833 18.333h8.334M14.167 18.333v-7.5H5.833v7.5M8.333 8.333h3.334", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17.5 7.5 10 3.333 2.5 7.5v10.833h15V7.5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { InsuranceHouse };
//# sourceMappingURL=InsuranceHouse.js.map
